import React, { FC, ReactNode, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import CommonZoneTab from "../../../containers/common-zones";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { showError } from "../../../services/utilities/ServiceError";
import { Filter } from "../../../models/Filter";
import { getListOfSiteIdsFromFilter, shouldUpdateCategory } from "../../../utilities/tabUtils";
import {useTabCount} from "../../../hooks/useCategoryTab";

const CommonZones: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    const { updateTabCount } = useTabCount({
        tableName: "CommonZone",
        categories,
        setCategories,
    });
    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.commonZones),
                    heading: translate.byKey(TranslationKeys.commonZones),
                    value: "",
                    id: 0,
                    count: 0,
                },
            ]);
            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
            setBusy(false);
        }
    }

    useEffect(() => {
        buildCategoriesData();
    }, []);

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [<CommonZoneTab setBusy={setBusy} categories={categories} onFilterChange={onFilterChange} setCategories={setCategories}/>];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onFilterChange = (filters: Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilter(filters);
        updateTabCount(siteIds)
    }

    return (
        <>
            <ActivityFrame
                busy={busy}
                className="flex flex-grow overflow-y-hidden">
                <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[{
                            value: "/access-control/hardware",
                            displayName: translate.byKey(TranslationKeys.hardware),
                        },
                        {
                            value: "/access-control/hardware/common-zones",
                            displayName: translate.byKey(TranslationKeys.commonZones),
                        },]}
                        onClick={(item) => history.push(item.value)} />
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                        <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                            <div className="flex flex-row justify-end button-cluster">
                                <Restricted to={`add.common-zones.element`}>
                                    <Link to={{ pathname: "/access-control/hardware/common-zone/", }}>
                                        <button className="flex rounded-lg bg-lime text-white p-2 shadow-lg" id='commonZoneAddButton'>
                                            <img
                                                src={plusIcon}
                                                className="px-2 w-8 py-1"
                                                alt="" />
                                            <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                        </button>
                                    </Link>
                                </Restricted>
                            </div>
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default CommonZones;
